<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  import Home from './components/Home'
  import Quiz from './components/Quiz'
  import Cookies from './components/Cookies'
  import GeneralConditions from './components/GeneralConditions'

  export default {
    name: 'app',
    components: {
      Home,
      Quiz,
      Cookies,
      GeneralConditions
    },
  }
</script>



// WEBPACK FOOTER //
// src/App.vue